(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-banner"] && !Shopify.designMode) return;
  try {
    
document.getElementById("sort-collections").addEventListener("change", function() {
    let sortBy = this.value;
    let container = document.querySelector(".collection-list");
    let items = Array.from(container.getElementsByClassName("collection-card"));

    if (sortBy === "title-ascending") {
        items.sort((a, b) => a.dataset.title.localeCompare(b.dataset.title));
    } else if (sortBy === "title-descending") {
        items.sort((a, b) => b.dataset.title.localeCompare(a.dataset.title));
    } else if (sortBy === "created-ascending") {
        items.sort((a, b) => new Date(a.dataset.date) - new Date(b.dataset.date));
    } else if (sortBy === "created-descending") {
        items.sort((a, b) => new Date(b.dataset.date) - new Date(a.dataset.date));
    }

    container.innerHTML = "";
    items.forEach(item => container.appendChild(item));
});

document.getElementById("grid-large").addEventListener("click", function() {
    let grid = document.getElementById("collection-grid");
    grid.classList.remove("grid-layout-medium");
    grid.classList.add("grid-layout-large");

    // Active button toggle
    document.getElementById("grid-large").classList.add("is-active");
    document.getElementById("grid-medium").classList.remove("is-active");
});

document.getElementById("grid-medium").addEventListener("click", function() {
    let grid = document.getElementById("collection-grid");
    grid.classList.remove("grid-layout-large");
    grid.classList.add("grid-layout-medium");

    // Active button toggle
    document.getElementById("grid-medium").classList.add("is-active");
    document.getElementById("grid-large").classList.remove("is-active");
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("click", function (event) {
        const sortButton = document.querySelector("#collection-toolbar__button");
        const shortingList = document.querySelector("#shorting_list");

        if (sortButton && shortingList && event.target.closest("#collection-toolbar__button")) {
            const isVisible = shortingList.style.display === "block";

            shortingList.style.display = isVisible ? "none" : "block";
            sortButton.classList.toggle("active", !isVisible);
        }
    });
});

  (function() {
    document.addEventListener("click", function(e) {
      const header = e.target.closest(".accordion-header");
      
      if (header) {
        const body = header.nextElementSibling;
        
        if (body && body.classList.contains('accordion-body')) {
          const isHidden = window.getComputedStyle(body).display === "none";

          if (isHidden) {
            body.style.display = "block";
            header.classList.remove("active");
          } else {
            body.style.display = "none";
            header.classList.add("active");
          }
        }
      }
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
/**
 * This script does:
 *   - Observes the DOM for the Rapi bundles to appear (using MutationObserver).
 *   - Once found, grabs the current Shopify base price and each pack’s prices, 
 *     and computes a ratio or difference to store.
 *   - Watches for changes to the .price-item.price-item--regular (LPO-updated price).
 *   - Recalculates each pack’s price to preserve that ratio/difference whenever the base price changes.
 */

// document.addEventListener('DOMContentLoaded', function() {

//   // ----- SELECTORS -----
//   const BASE_PRICE_SELECTOR = '.price-list .money';
//   const RAPI_CONTAINER_SELECTOR = '.rapi-bundles__bar-pricing';
//   const RAPI_PRICE_SELECTOR = '.rapi-bundles__bar-price';
//   const RAPI_FULL_PRICE_SELECTOR = '.rapi-bundles__bar-full-price';

//   // We'll store ratio data here once we detect the bundles.
//   let packData = [];
//   let originalBasePrice = 0; // so we know what the base was when we calculated ratios

//   /**
//    * Parse text like "$38.99 CAD" into a number 38.99
//    */
//   function parsePrice(str) {
//     if (!str) return 0;
//     return parseFloat(str.replace(/[^\d.]/g, '')) || 0;
//   }

//   /**
//    * Read the current Shopify base price from the DOM
//    */
//   function getBasePrice() {
//     const el = document.querySelector(BASE_PRICE_SELECTOR);
//     if (!el) return 0;
//     return parsePrice(el.innerText);
//   }

//   /**
//    * Capture each pack's ratio (pack price / base price) at the moment we first find them.
//    */
//   function storePackData() {
//     packData = []; // clear old data in case of re-run

//     originalBasePrice = getBasePrice();
//     if (!originalBasePrice) {
//       console.warn('Base price is 0 or not found. Cannot store pack ratios yet.');
//       return;
//     }

//     // Grab each container
//     const containers = document.querySelectorAll(RAPI_CONTAINER_SELECTOR);
//     containers.forEach((container, index) => {
//       const priceEl = container.querySelector(RAPI_PRICE_SELECTOR);
//       if (!priceEl) return; // skip if no main price

//       const fullPriceEl = container.querySelector(RAPI_FULL_PRICE_SELECTOR);

//       // Current displayed prices
//       const currentPrice = parsePrice(priceEl.innerText);
//       const currentFullPrice = fullPriceEl ? parsePrice(fullPriceEl.innerText) : 0;

//       // RATIO approach: ratio = pack price / base price
//       const ratio = currentPrice / originalBasePrice;
//       const fullRatio = fullPriceEl ? (currentFullPrice / originalBasePrice) : 0;

//       // We'll store references + ratio info for each container
//       packData.push({
//         container,
//         priceEl,
//         fullPriceEl,
//         ratio,
//         fullRatio
//       });
//     });

//     console.log(`\n=== Stored Rapi pack data for ${packData.length} packs ===`);
//     packData.forEach((p, i) => {
//       console.log(`Pack #${i}: ratio=${p.ratio.toFixed(3)} fullRatio=${p.fullRatio.toFixed(3)}`);
//     });
//   }

//   /**
//    * Whenever the base price changes, update each pack so it remains at the same ratio.
//    */
//   function updatePacksForNewBasePrice() {
//     const newBasePrice = getBasePrice();
//     if (!newBasePrice || packData.length === 0) return;

//     console.log(`\nBase price changed -> Updating ${packData.length} pack(s) to maintain ratio...`);

//     packData.forEach((p, i) => {
//       const newPrice = newBasePrice * p.ratio;
//       p.priceEl.innerText = `$${newPrice.toFixed(2)} `;

//       if (p.fullPriceEl) {
//         const newFullPrice = newBasePrice * p.fullRatio;
//         p.fullPriceEl.innerText = `$${newFullPrice.toFixed(2)}`;
//       }
//     });
//   }

//   /**
//    * 1) Observe the entire body for new .rapi-bundles__bar-pricing elements
//    * 2) Once found, store the ratio data
//    * 3) Observe the .price-item--regular for changes
//    */
//   (function setupObservers() {
//     let rapiFound = false;

//     // Watch for Rapi elements to appear in the DOM
//     const bodyObserver = new MutationObserver(function(mutations, obs) {
//       const containers = document.querySelectorAll(RAPI_CONTAINER_SELECTOR);
//       if (containers.length > 0 && !rapiFound) {
//         rapiFound = true;
//         console.log('[DEBUG] Found Rapi bundle containers. Storing pack data...');
//         storePackData();
//         // Optionally disconnect if we only want to store data once
//         // obs.disconnect();

//         // Now observe the base price for changes
//         observeBasePrice();
//       }
//     });
//     bodyObserver.observe(document.body, { childList: true, subtree: true });
//   })();


//   /**
//    * Set up a MutationObserver on the base price element so we know when it changes
//    */
//   function observeBasePrice() {
//     const baseEl = document.querySelector(BASE_PRICE_SELECTOR);
//     if (!baseEl) {
//       console.warn('No base price element found to observe!');
//       return;
//     }

//     const baseObserver = new MutationObserver(function(mutations) {
//       // Each time the .price-item--regular text changes, recalc pack prices:
//       updatePacksForNewBasePrice();
//     });
//     baseObserver.observe(baseEl, {
//       characterData: true,
//       childList: true,
//       subtree: true
//     });
//   }

// });


// popup open close js
document.addEventListener("DOMContentLoaded", function () {
  const interval = setInterval(() => {
    const btn = document.querySelector(".engraving-btn");
    if (btn) {
      clearInterval(interval);

      const modal = document.querySelector(".engraving-modal");
      const closeBtn1 = modal.querySelector(".close-btn");
      const closeBtn2 = modal.querySelector(".continue-btn");

      btn.addEventListener("click", function () {
        modal.style.display = "flex";
        document.body.classList.add("modal-open"); 
      });

      function closeModal() {
        modal.style.display = "none";
        document.body.classList.remove("modal-open"); 
      }

      closeBtn1.addEventListener("click", closeModal);
      closeBtn2.addEventListener("click", closeModal);
    }
  }, 500);
});
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-collection-products-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
      var swiper1 = new Swiper("#related-collection", {
        slidesPerView: 3.5,
        spaceBetween: 10,
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1024: { slidesPerView: 3.5 },
          820: { slidesPerView: 3.5 },
          320: { slidesPerView: 1.5 },
        },
      });
    });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-color-banner"] && !Shopify.designMode) return;
  try {
    
document.getElementById("sort-collections").addEventListener("change", function() {
    let sortBy = this.value;
    let container = document.querySelector(".collection-list");
    let items = Array.from(container.getElementsByClassName("collection-card"));

    if (sortBy === "title-ascending") {
        items.sort((a, b) => a.dataset.title.localeCompare(b.dataset.title));
    } else if (sortBy === "title-descending") {
        items.sort((a, b) => b.dataset.title.localeCompare(a.dataset.title));
    } else if (sortBy === "created-ascending") {
        items.sort((a, b) => new Date(a.dataset.date) - new Date(b.dataset.date));
    } else if (sortBy === "created-descending") {
        items.sort((a, b) => new Date(b.dataset.date) - new Date(a.dataset.date));
    }

    container.innerHTML = "";
    items.forEach(item => container.appendChild(item));
});

document.getElementById("grid-large").addEventListener("click", function() {
    let grid = document.getElementById("collection-grid");
    grid.classList.remove("grid-layout-medium");
    grid.classList.add("grid-layout-large");

    // Active button toggle
    document.getElementById("grid-large").classList.add("is-active");
    document.getElementById("grid-medium").classList.remove("is-active");
});

document.getElementById("grid-medium").addEventListener("click", function() {
    let grid = document.getElementById("collection-grid");
    grid.classList.remove("grid-layout-large");
    grid.classList.add("grid-layout-medium");

    // Active button toggle
    document.getElementById("grid-medium").classList.add("is-active");
    document.getElementById("grid-large").classList.remove("is-active");
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-style-banner"] && !Shopify.designMode) return;
  try {
    
document.getElementById("sort-collections").addEventListener("change", function() {
    let sortBy = this.value;
    let container = document.querySelector(".collection-list");
    let items = Array.from(container.getElementsByClassName("collection-card"));

    if (sortBy === "title-ascending") {
        items.sort((a, b) => a.dataset.title.localeCompare(b.dataset.title));
    } else if (sortBy === "title-descending") {
        items.sort((a, b) => b.dataset.title.localeCompare(a.dataset.title));
    } else if (sortBy === "created-ascending") {
        items.sort((a, b) => new Date(a.dataset.date) - new Date(b.dataset.date));
    } else if (sortBy === "created-descending") {
        items.sort((a, b) => new Date(b.dataset.date) - new Date(a.dataset.date));
    }

    container.innerHTML = "";
    items.forEach(item => container.appendChild(item));
});

document.getElementById("grid-large").addEventListener("click", function() {
    let grid = document.getElementById("collection-grid");
    grid.classList.remove("grid-layout-medium");
    grid.classList.add("grid-layout-large");

    // Active button toggle
    document.getElementById("grid-large").classList.add("is-active");
    document.getElementById("grid-medium").classList.remove("is-active");
});

document.getElementById("grid-medium").addEventListener("click", function() {
    let grid = document.getElementById("collection-grid");
    grid.classList.remove("grid-layout-large");
    grid.classList.add("grid-layout-medium");

    // Active button toggle
    document.getElementById("grid-medium").classList.add("is-active");
    document.getElementById("grid-large").classList.remove("is-active");
});


  } catch(e) { console.error(e); }
})();
})();
